/* eslint-disable no-unused-vars */
import React from 'react';

import {
  BrowserRouter as Router, Switch,
} from 'react-router-dom';

import { Route } from './route';
import { routes } from './routes';

export default function Routes() {
  return (
    <Router>
      <Switch>
        {routes.map(({ Component, routeName, ...rest }) => (
          <Route {...rest}>
            <Component action={routeName || null} />
          </Route>
        ))}
      </Switch>
    </Router>
  );
}
